import { useState } from 'react';
import { OrgUnitsTree } from '../components/admin/org-units/OrgUnitsTree';
import { OrgUnitDetail } from '../components/admin/org-units/OrgUnitDetail';
import { OrgUnitSiteBindingModal } from '../components/admin/org-units/OrgUnitSiteBindingModal';
import { OrgUnitCascadeDeleteDialog } from '../components/admin/org-units/OrgUnitCascadeDeleteDialog';
import { useOrgUnits } from '../hooks/useOrgUnits';
import type { OrgUnitSelection } from '../types/orgUnit';

export function AdminOrgUnits() {
  const orgUnitsQuery = useOrgUnits();
  const [selection, setSelection] = useState<OrgUnitSelection>({ kind: 'none' });
  const [bindingFor, setBindingFor] = useState<string | null>(null);
  const [deletingFor, setDeletingFor] = useState<string | null>(null);

  const orgUnits = orgUnitsQuery.data ?? [];

  return (
    <div className="flex flex-1 bg-ems-bg-card text-ems-text-primary">
      <div className="w-[38%] min-w-[280px] max-w-[480px] flex-shrink-0">
        <OrgUnitsTree
          orgUnits={orgUnits}
          selection={selection}
          onSelect={setSelection}
          onAddOrganization={() => setSelection({ kind: 'create', type: 'organization' })}
          onAddRegion={(parentId) =>
            setSelection({ kind: 'create', type: 'region', parent_id: parentId ?? null })
          }
          onAddDistrict={(parentId) =>
            setSelection({ kind: 'create', type: 'district', parent_id: parentId })
          }
        />
      </div>

      <div className="flex-1">
        <OrgUnitDetail
          selection={selection}
          orgUnits={orgUnits}
          onClearSelection={() => setSelection({ kind: 'none' })}
          onBindSites={(id) => setBindingFor(id)}
          onDelete={(id) => setDeletingFor(id)}
        />
      </div>

      {bindingFor && (
        <OrgUnitSiteBindingModal
          orgUnitId={bindingFor}
          onClose={() => setBindingFor(null)}
        />
      )}

      {deletingFor && (
        <OrgUnitCascadeDeleteDialog
          orgUnitId={deletingFor}
          orgUnits={orgUnits}
          onClose={() => setDeletingFor(null)}
          onDeleted={() => {
            setDeletingFor(null);
            setSelection({ kind: 'none' });
          }}
        />
      )}
    </div>
  );
}
